import React from 'react';
import Icon from '../../Icon/components/Icon';

const SuperscriptIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 19l8-8"/>
      <path d="M12 19l8-8"/>
      <path d="M15 4l-1.5 1.5 1.5 1.5 1.5-1.5L15 4z" strokeWidth="1.5"/>
      <line x1="13.5" y1="3" x2="16.5" y2="3" strokeWidth="1.5"/>
    </Icon>
  );
};

export default SuperscriptIcon;
